jQuery(document).ready(function($){
  $(document).ready(function() {
    if (window.location.href.indexOf('?scroll-footer') > -1) {
        setTimeout(()=>{
            var footerPosition = $('#footer_scroll_tag').offset().top;
            $('html, body').animate({
                scrollTop: footerPosition
            }, 'slow');
        }, 2500);
    }
  });
});